export default __webpack_public_path__ + "static/Brandon-Light-300-0fb1f399ed0ddc7ade9558557b390e44.woff";